import type { EnterpriseInvitationUser } from '@m/types/api/EnterpriseInvitation';

/**
 * Why this onboarding session exists — drives copy (`onboardingCopy`) and which fields are
 * required. Kept as a flat union rather than nested booleans so a view's `variant` prop reads
 * as one clear value instead of a combination the caller has to reconstruct.
 */
export type OnboardingVariant = 'agnostic' | 'enterpriseSub' | 'individualSub' | 'locationSpecific';

export type DeriveVariantContext = {
  enterpriseUser: EnterpriseInvitationUser | undefined;
  individualSubscriptionInvitationId: string | null | undefined;
  siteId: number | null | undefined;
};

/**
 * Pure derivation, first match wins. Enterprise and individual-subscription invites are known
 * the moment the invite link is parsed — well before any site resolves — so they take priority
 * over `siteId`, which a subscription invitee visiting a specific lot would otherwise also have.
 *
 * Callers resolve `enterpriseUser` / `individualSubscriptionInvitationId` / `siteId` from
 * whichever store already holds them (userStore, membershipStore, the active visit's site) —
 * this function only encodes the precedence, not where the values come from.
 */
export function deriveVariant(ctx: DeriveVariantContext): OnboardingVariant {
  if (ctx.enterpriseUser) return 'enterpriseSub';
  if (ctx.individualSubscriptionInvitationId) return 'individualSub';
  if (ctx.siteId != null) return 'locationSpecific';
  return 'agnostic';
}
